import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import HttpsRedirect from 'react-https-redirect';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <HttpsRedirect disabled={process.env.NODE_ENV==="development"}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </HttpsRedirect>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
